// Copied verbatim from the desktop app so the two look identical.
// Do not edit here: change the app's copy, then run
//   node scripts/sync-app-components.mjs --write
// `pnpm verify:components` fails the build if the two drift apart.
import * as React from "react";
import { Popover as PopoverPrimitive } from "radix-ui";

import { cn } from "@/lib/utils";

function Popover({ ...props }: React.ComponentProps<typeof PopoverPrimitive.Root>) {
  return <PopoverPrimitive.Root data-slot="popover" {...props} />;
}

function PopoverTrigger({ ...props }: React.ComponentProps<typeof PopoverPrimitive.Trigger>) {
  return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />;
}

function PopoverAnchor({ ...props }: React.ComponentProps<typeof PopoverPrimitive.Anchor>) {
  return <PopoverPrimitive.Anchor data-slot="popover-anchor" {...props} />;
}

function PopoverContent({
  className,
  align = "center",
  sideOffset = 8,
  container,
  portal = true,
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Content> & {
  /** Portal host — use the fullscreen element so menus stay visible there. */
  container?: HTMLElement | null;
  /**
   * When false, render in-tree (no body portal). Use outside fullscreen so
   * page chrome like the watch header stays above the menu.
   */
  portal?: boolean;
}) {
  const content = (
    <PopoverPrimitive.Content
      data-slot="popover-content"
      align={align}
      sideOffset={sideOffset}
      className={cn(
        // pointer-events-auto: watch menu layer is pointer-events-none so scroll
        // passes through; portaled menus must opt back in.
        // app-no-drag: same as SelectContent / ContextMenu — menus portal over
        // window drag regions and need an explicit no-drag to stay clickable.
        "app-no-drag pointer-events-auto z-50 w-72 origin-(--radix-popover-content-transform-origin) rounded-xl border border-border bg-popover p-1 text-popover-foreground shadow-lg outline-none animate-in fade-in-0 zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
        className
      )}
      {...props}
    />
  );

  if (!portal) return content;

  return (
    <PopoverPrimitive.Portal container={container ?? undefined}>{content}</PopoverPrimitive.Portal>
  );
}

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor };
